function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.16,
    height: 8.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.10875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 4.435,
    fontFamily: "Arial"
  }, "\n        Keweenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.87,
    width: 15.16,
    height: 19.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 18.71,
    fontFamily: "Arial"
  }, "\n        Luce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.55,
    width: 15.16,
    height: 27.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 42.27,
    fontFamily: "Arial"
  }, "\n        Baraga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.99,
    width: 15.16,
    height: 28.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 70.47,
    fontFamily: "Arial"
  }, "\n        Oscoda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84.96,
    width: 15.16,
    height: 31.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3781818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 100.57,
    fontFamily: "Arial"
  }, "\n        Schoolcraft\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116.18,
    width: 15.16,
    height: 34.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 133.365,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 150.55,
    width: 15.16,
    height: 34.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.032
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 167.82500000000002,
    fontFamily: "Arial"
  }, "\n        Alger\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 185.1,
    width: 15.16,
    height: 35.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6844444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 203.035,
    fontFamily: "Arial"
  }, "\n        Ontonagon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.97,
    width: 15.16,
    height: 36.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3781818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 239.07999999999998,
    fontFamily: "Arial"
  }, "\n        Montmorency\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.19,
    width: 15.16,
    height: 43.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 279.03499999999997,
    fontFamily: "Arial"
  }, "\n        Alcona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300.89,
    width: 15.16,
    height: 44.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 323.28999999999996,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 345.68,
    width: 15.16,
    height: 45.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 368.275,
    fontFamily: "Arial"
  }, "\n        Mackinac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.87,
    width: 15.16,
    height: 45.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6844444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 413.77,
    fontFamily: "Arial"
  }, "\n        Missaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 436.67,
    width: 15.16,
    height: 48.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 460.96000000000004,
    fontFamily: "Arial"
  }, "\n        Kalkaska\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 485.26,
    width: 15.16,
    height: 51.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 511.15999999999997,
    fontFamily: "Arial"
  }, "\n        Benzie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 537.06,
    width: 15.16,
    height: 52.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 563.52,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 589.99,
    width: 15.16,
    height: 54.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 617.23,
    fontFamily: "Arial"
  }, "\n        Arenac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.47,
    width: 15.16,
    height: 55.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.58,
    y: 672.235,
    fontFamily: "Arial"
  }, "\n        Presque_Isle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 0,
    width: 29.32,
    height: 35.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.886666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.82,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Ogemaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.48,
    y: 0,
    width: 29.58,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.269999999999996,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 0,
    width: 29.64,
    height: 35.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.234285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.88,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Gogebic\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 0,
    width: 30.12,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.76,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 0,
    width: 32.1,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.88000000000002,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Antrim\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.93,
    y: 0,
    width: 32.73,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.09125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.29500000000002,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Leelanau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.66,
    y: 0,
    width: 33.92,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.653333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.62,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Oceana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.58,
    y: 0,
    width: 34.62,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.945714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.89000000000001,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Gladwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.2,
    y: 0,
    width: 34.91,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8788888888888886
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.655,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Cheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.11,
    y: 0,
    width: 35.61,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.915,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.71,
    y: 0,
    width: 37.03,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.568
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.22499999999997,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Charlevoix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.74,
    y: 0,
    width: 37.43,
    height: 35.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.455,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Manistee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.18,
    y: 0,
    width: 38.58,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.964444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.47,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Roscommon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.75,
    y: 0,
    width: 39.08,
    height: 35.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.29,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Clare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.83,
    y: 0,
    width: 40.4,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.097142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.03,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Wexford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.24,
    y: 0,
    width: 41.87,
    height: 35.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.964444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.175,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Dickinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.11,
    y: 0,
    width: 42.03,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.125,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.14,
    y: 0,
    width: 42.51,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 635.395,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Emmet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 656.65,
    y: 0,
    width: 43.35,
    height: 35.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.3249999999999,
    y: 17.84,
    fontFamily: "Arial"
  }, "\n        Iosco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 35.68,
    width: 46.64,
    height: 33.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 52.45,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 69.22,
    width: 46.64,
    height: 37.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.173333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 87.74,
    fontFamily: "Arial"
  }, "\n        Alpena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 106.26,
    width: 46.64,
    height: 37.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 124.905,
    fontFamily: "Arial"
  }, "\n        Houghton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 143.55,
    width: 46.64,
    height: 38.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 163.01000000000002,
    fontFamily: "Arial"
  }, "\n        Mecosta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 182.47,
    width: 46.64,
    height: 39.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.575714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 201.985,
    fontFamily: "Arial"
  }, "\n        Gratiot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 221.5,
    width: 46.64,
    height: 40.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 241.89,
    fontFamily: "Arial"
  }, "\n        Branch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 262.29,
    width: 46.64,
    height: 40.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 282.73,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 303.17,
    width: 46.64,
    height: 43.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.885555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 325.15500000000003,
    fontFamily: "Arial"
  }, "\n        Hillsdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 347.14,
    width: 46.64,
    height: 44.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.291428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 369.15999999999997,
    fontFamily: "Arial"
  }, "\n        Newaygo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 391.18,
    width: 46.64,
    height: 44.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 413.255,
    fontFamily: "Arial"
  }, "\n        Delta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 435.33,
    width: 46.64,
    height: 46.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.587142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 458.385,
    fontFamily: "Arial"
  }, "\n        Sanilac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 481.44,
    width: 46.64,
    height: 49.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 506.365,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 531.29,
    width: 46.64,
    height: 54.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 558.375,
    fontFamily: "Arial"
  }, "\n        Isabella\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 585.46,
    width: 46.64,
    height: 55.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 613.455,
    fontFamily: "Arial"
  }, "\n        Montcalm\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.16,
    y: 641.45,
    width: 46.64,
    height: 58.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.480000000000004,
    y: 670.725,
    fontFamily: "Arial"
  }, "\n        Ionia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 35.68,
    width: 44.3,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 83.94999999999999,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        St._Joseph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.1,
    y: 35.68,
    width: 45.46,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.82999999999998,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Barry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.56,
    y: 35.68,
    width: 45.58,
    height: 62.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.511428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.35,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Tuscola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.14,
    y: 35.68,
    width: 55.88,
    height: 62.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.20888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.07999999999998,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Van_Buren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.02,
    y: 35.68,
    width: 56.07,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.055,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.09,
    y: 35.68,
    width: 58.45,
    height: 62.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4944444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.315,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.54,
    y: 35.68,
    width: 59.8,
    height: 62.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.44,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Shiawassee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.35,
    y: 35.68,
    width: 63.69,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.430714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.19500000000005,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Grand_Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.03,
    y: 35.68,
    width: 64.84,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.338333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.4499999999999,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Lapeer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.87,
    y: 35.68,
    width: 71.38,
    height: 62.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.861428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.56,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Midland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.25,
    y: 35.68,
    width: 72.75,
    height: 62.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.861428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.625,
    y: 66.695,
    fontFamily: "Arial"
  }, "\n        Lenawee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 97.7,
    width: 73.69,
    height: 63.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.074285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 129.46,
    fontFamily: "Arial"
  }, "\n        Allegan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 161.23,
    width: 73.69,
    height: 74.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 198.475,
    fontFamily: "Arial"
  }, "\n        Eaton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 235.71,
    width: 73.69,
    height: 84.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.563333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 277.985,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 320.26,
    width: 73.69,
    height: 91.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 365.91999999999996,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 411.58,
    width: 73.69,
    height: 91.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 457.495,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 503.41,
    width: 73.69,
    height: 96.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.369
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 551.4250000000001,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 599.44,
    width: 73.69,
    height: 100.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.645,
    y: 649.72,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.49,
    y: 97.7,
    width: 74.65,
    height: 102.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.294444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.815,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.14,
    y: 97.7,
    width: 77.76,
    height: 102.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.108571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.01999999999998,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 97.7,
    width: 80.37,
    height: 102.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.085,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        Muskegon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.27,
    y: 97.7,
    width: 107.47,
    height: 102.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.103333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.005,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.74,
    y: 97.7,
    width: 108.25,
    height: 102.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.865,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        Saginaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.99,
    y: 97.7,
    width: 116.01,
    height: 102.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.402222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.995,
    y: 149.01,
    fontFamily: "Arial"
  }, "\n        Kalamazoo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.49,
    y: 200.32,
    width: 163.75,
    height: 93.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.365,
    y: 247.14999999999998,
    fontFamily: "Arial"
  }, "\n        Ingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.49,
    y: 293.98,
    width: 163.75,
    height: 96.23,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.692222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.365,
    y: 342.095,
    fontFamily: "Arial"
  }, "\n        Washtenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.49,
    y: 390.21,
    width: 163.75,
    height: 140,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.365,
    y: 460.21,
    fontFamily: "Arial"
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.49,
    y: 530.21,
    width: 163.75,
    height: 169.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.9375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.365,
    y: 615.105,
    fontFamily: "Arial"
  }, "\n        Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.24,
    y: 200.32,
    width: 154.65,
    height: 258.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.775000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.565,
    y: 329.745,
    fontFamily: "Arial"
  }, "\n        Macomb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.89,
    y: 200.32,
    width: 246.11,
    height: 258.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.15857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.9449999999999,
    y: 329.745,
    fontFamily: "Arial"
  }, "\n        Oakland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.24,
    y: 459.18,
    width: 400.76,
    height: 240.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 48.164
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.62,
    y: 579.59,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.e1d835786035bd4492ef5fe6a6358074.svg";
export { ForwardRef as ReactComponent };